/**
 * @generated SignedSource<<70e61118711ba0ddbec810262eff178c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShippingType_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useShippingPrice_item">;
  readonly " $fragmentType": "useShippingType_item";
};
export type useShippingType_item$key = {
  readonly " $data"?: useShippingType_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShippingType_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "itemQuantity"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShippingType_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "fetchShippingCostInfo",
          "value": true
        },
        {
          "kind": "Variable",
          "name": "itemQuantity",
          "variableName": "itemQuantity"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useShippingPrice_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "32f3a157325ca9b5b02426d679e01ec2";

export default node;
